module.exports = {"addressInfo":"Charge.gg","sentBecauseAction":"This email was sent because of opt-in on charge.gg"};